import { SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';

interface Option {
  value: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: Option[];
  label?: string;
  error?: string;
}

export function Select({ 
  options, 
  label,
  error,
  className = '', 
  ...props 
}: SelectProps) {
  return (
    <div className="relative">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          className={`
            appearance-none
            w-full
            px-3
            py-2
            bg-white
            border
            rounded-md
            shadow-sm
            text-base
            text-gray-700
            transition-colors
            duration-200
            ease-in-out
            disabled:bg-gray-50
            disabled:text-gray-500
            disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 
              'border-gray-300 focus:ring-blue-500 focus:border-blue-500'}
            focus:outline-none
            focus:ring-1
            focus:ring-offset-0
            ${className}
          `}
          {...props}
        >
          <option value="" className="text-gray-500">Selecione uma opção</option>
          {options.map((option) => (
            <option 
              key={option.value} 
              value={option.value}
              className="text-gray-700"
            >
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
          <ChevronDown className="h-5 w-5 text-gray-400" />
        </div>
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
} 